import { render, staticRenderFns } from "./CreateAccountFormAccount.vue?vue&type=template&id=6101cf1a&"
import script from "./CreateAccountFormAccount.vue?vue&type=script&lang=js&"
export * from "./CreateAccountFormAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountFormAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports